// Legacy storefront search overlay — do NOT hijack the ETournify header search.
document.addEventListener('DOMContentLoaded', function () {
  // Real search is the header player/team/tournament panel.
  if (document.querySelector('[id^="etn-header-player-search-toggle-"]')) {
    var legacy = document.getElementById('searchOverlay');
    if (legacy) legacy.style.display = 'none';
    return;
  }

  var searchTrigger = document.getElementById('searchTrigger');
  var searchOverlay = document.getElementById('searchOverlay');
  var searchClose = document.getElementById('searchClose');
  var searchInput = document.getElementById('searchInput');

  if (!searchTrigger || !searchOverlay) return;

  searchTrigger.addEventListener('click', function (e) {
    e.preventDefault();
    searchOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 100);
  });

  function closeSearch() {
    searchOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (searchClose) searchClose.addEventListener('click', closeSearch);

  searchOverlay.addEventListener('click', function (e) {
    if (e.target === searchOverlay) closeSearch();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
      closeSearch();
    }
  });
});
